import {
  getColorButtonAnimation,
  iconButtonAnimation,
} from "@domains/common/utils/animationHelper";
import { Share2Icon } from "@enkor/design/icons";
import { grayScale, pink } from "@enkor/design/colors";
import { DATA_TRACKING_EVENT_NAME } from "@domains/common/constants/dataTrackEventName";
import { dataTrackEvent } from "@logics/utils/dataTrackEvent";
import useModalState from "@logics/hooks/useModalState";
import { EventInfoTrackingDataType } from "@domains/event/types/event";
import { GA_EVENT_IDS } from "@domains/common/constants/googleAnalyticsIds";

import CancelReasonBottomSheet from "../../CancelReasonBottomSheet/CancelReasonBottomSheet";

import * as S from "./CancelButtonGroup.style";

interface CancelButtonGroupProps {
  eventId: string;
  eventInfo: EventInfoTrackingDataType;
  isEventClosed?: boolean;
  onClickShare: () => void;
  onClickChatRoom: () => void;
}

const CancelButtonGroup = ({
  eventId,
  eventInfo,
  isEventClosed,
  onClickShare,
  onClickChatRoom,
}: CancelButtonGroupProps) => {
  const { openModal } = useModalState();

  const handleClickCancelation = () => {
    dataTrackEvent({
      eventName: DATA_TRACKING_EVENT_NAME.GUEST_EVENT.CLICK_START_EVENT_LEAVE,
      properties: eventInfo,
    });

    openModal({
      CustomComponent: (
        <CancelReasonBottomSheet eventId={eventId} eventInfo={eventInfo} />
      ),
    });
  };

  return (
    <S.SpacedBetweenWrapper>
      <S.ShareButtonBox
        type="button"
        id={GA_EVENT_IDS.EVENT.GUEST_SHARE}
        {...iconButtonAnimation}
        onClick={onClickShare}
      >
        <Share2Icon strokeColor={grayScale.white} />
      </S.ShareButtonBox>
      <S.UnderlineButton
        type="button"
        id={GA_EVENT_IDS.EVENT.GUEST_START_LEAVE}
        disabled={isEventClosed}
        onClick={handleClickCancelation}
      >
        Cancel
      </S.UnderlineButton>
      <S.FullButton
        type="button"
        {...getColorButtonAnimation({
          hoverColor: pink[300],
          tapColor: pink[200],
        })}
        onClick={onClickChatRoom}
      >
        Chat room
      </S.FullButton>
    </S.SpacedBetweenWrapper>
  );
};

export default CancelButtonGroup;
